import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }

import BaseModal from "@/components/Modal/BaseModal.vue";


interface Props {
  errorMessage: string; // Error message has to be also defined in locales
}

interface Emits {
  (e: "close"): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    errorMessage: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  errorMessage: string; // Error message has to be also defined in locales
}



const endNowTimeout = 30 * 1000; // 30 seconds

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    onCloseOnTimeout: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
    timeout: endNowTimeout
  }, {
    message: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t(props.errorMessage)), 1)
    ]),
    actions: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
          class: "bg-accent text-white py-3.5 px-16 rounded-sm"
        }, _toDisplayString(_ctx.$t("ok")), 1)
      ])
    ]),
    _: 1
  }))
}
}

})